import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { ref, reactive, onMounted } from "vue";
// import upload from "@/components/upload/index.vue";
import { useI18n } from "vue-i18n";
import api from "@/api/system/users";
import rolesApi from "@/api/system/roles";
import { ElMessage } from "element-plus";
export default {
  __name: 'dialog',
  props: {
    labelList: {
      type: Array,
      default: () => []
    }
  },
  emits: ["loadList"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      t
    } = useI18n();
    const title = ref("");
    const showDialog = ref(false);
    const params = reactive({
      userName: "",
      // 账号
      name: "",
      // 昵称
      roleId: "",
      // 角色id
      id: "",
      introduction: "",
      // 简洁
      avatar: "" // 头像
    });
    const rules = reactive({
      userName: [{
        required: true,
        message: t("common.pleaseEnter", {
          val: t("users.form.userName")
        }),
        trigger: "blur"
      }, {
        min: 5,
        max: 20,
        message: t("users.message.userNameLength", {
          min: 5,
          max: 20
        }),
        // 自定义的提示信息
        trigger: "blur"
      }],
      name: [{
        required: true,
        message: t("common.pleaseEnter", {
          val: t("users.table.name")
        }),
        trigger: "blur"
      }],
      roleId: [{
        required: true,
        message: t("common.pleaseSelect", {
          val: t("users.form.roleId")
        }),
        trigger: "change"
      }],
      avatar: [{
        required: true,
        message: t("common.pleaseSelect", {
          val: t("users.table.avatar")
        }),
        trigger: "change"
      }]
    });
    const formRef = ref(null);
    const handleClose = () => {
      formRef.value.resetFields();
    };
    const emit = __emit;
    const open = row => {
      title.value = row ? `${t("common.edit")}${t("users.table.username")} - ${row.username}` : `${t("common.add")}${t("users.table.username")}`;
      Object.assign(params, {
        userName: row ? row.username : "",
        name: row ? row.name : "",
        roleId: row ? row.roleId : "",
        id: row ? row.id : "",
        introduction: row ? row.introduction : "",
        avatar: row ? row.avatar : ""
      });
      showDialog.value = true;
    };
    const loading = ref(false);
    const handleConfig = () => {
      formRef.value.validate(async valid => {
        if (!valid) return;
        try {
          loading.value = true;
          const {
            data
          } = params.id ? await api.editUser(params) : await api.addUser(params);
          if (data.code !== 0) return;
          showDialog.value = false;
          ElMessage.success(t("action.success"));
          emit("loadList");
        } finally {
          loading.value = false;
        }
      });
    };
    const rolesList = ref([]);
    // 获取角色列表
    const getRolesList = async () => {
      const {
        data
      } = await rolesApi.rolesList();
      if (data.code !== 0) return;
      rolesList.value = data.data.list;
    };
    onMounted(() => {
      getRolesList();
    });
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: title.value,
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => showDialog.value = $event),
        width: "35%",
        onClose: handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => showDialog.value = false),
          size: "large"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          loading: loading.value,
          onClick: handleConfig
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("action.confirmBtn")), 1)]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          model: params,
          size: "large",
          ref_key: "formRef",
          ref: formRef,
          rules: rules,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: _ctx.$t('users.table.username'),
            prop: "userName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: _ctx.$t('common.pleaseEnter', {
                val: _ctx.$t('users.table.username')
              }),
              modelValue: params.userName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.userName = $event),
              modelModifiers: {
                trim: true
              },
              clearable: ""
            }, null, 8, ["placeholder", "modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('users.table.name'),
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: _ctx.$t('common.pleaseEnter', {
                val: _ctx.$t('users.table.name')
              }),
              modelValue: params.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => params.name = $event),
              clearable: ""
            }, null, 8, ["placeholder", "modelValue"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('users.form.roleId'),
            prop: "roleId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: params.roleId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => params.roleId = $event),
              teleported: false,
              clearable: "",
              placeholder: _ctx.$t('common.pleaseSelect', {
                val: _ctx.$t('users.form.roleId')
              })
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rolesList.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "placeholder"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, {
            label: _ctx.$t('users.table.introduction'),
            prop: "introduction"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: params.introduction,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => params.introduction = $event),
              clearable: "",
              rows: 4,
              type: "textarea"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["model", "rules"])])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }
};